import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import { alpha, useTheme } from "@mui/material/styles";

const DURATION_MS = 640;

function TopProgressBar() {
  const location = useLocation();
  const theme = useTheme();
  const [runId, setRunId] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setRunId((n) => n + 1);
    setVisible(true);
    const timeoutId = setTimeout(() => setVisible(false), DURATION_MS);
    return () => clearTimeout(timeoutId);
  }, [location.pathname]);

  if (!visible) return null;

  return (
    <>
      <style>{`
        @keyframes topbar-progress {
          0%   { transform: scaleX(0);   opacity: 0.72; }
          72%  { transform: scaleX(0.9); opacity: 0.72; }
          100% { transform: scaleX(1);   opacity: 0; }
        }
      `}</style>
      <Box
        key={runId}
        aria-hidden
        sx={{
          animation: `topbar-progress ${DURATION_MS}ms ease-out forwards`,
          backgroundColor: alpha(theme.palette.primary.main, 0.72),
          height: 2,
          left: 0,
          pointerEvents: "none",
          position: "fixed",
          top: 0,
          transformOrigin: "left center",
          width: "100%",
          zIndex: theme.zIndex.appBar + 2,
        }}
      />
    </>
  );
}

export default TopProgressBar;
